export const lcvCampaignConstants = {
    LCV_CAMPAIGNS_GET_REQUEST:"LCV_CAMPAIGNS_GET_REQUEST",
    LCV_CAMPAIGNS_GET_COMPLETE:"LCV_CAMPAIGNS_GET_COMPLETE",

    LCV_CAMPAIGN_SELECT:"LCV_CAMPAIGN_SELECT",
};
